import React from "react";
import { ADD_PAYMENT_INFO, SHIPMENT_SUMMARY } from "constants/global";
import { Form } from "react-bootstrap";
import AssignSupplier from "component/flex/AssignSupplier";

const AddReceiverInfo = ({
    goToStep,
    business,
    setIsReceiver,
    isReceiver,
    selectedSupplier,
    setSelectedSupplier,
    isForthStepValid,
    isLoading,
}) => {
    console.log({selectedSupplier});
    return (
        <>
            <h3 className="text-main-dark font-[450] text-2xl !mb-6">Add receivers information</h3>
            <AssignSupplier
                business={business}
                selectedSupplier={selectedSupplier}
                setSelectedSupplier={setSelectedSupplier}
                type={"buyer"}
                label="Who is receiving this shipment?"
                subLabel="Select receiver"
                isReceiver={isReceiver}
            />

            <div htmlFor="" className="text-[14px] leading-[19.6px] font-medium mt-2 text-gray-10">
                <Form.Check
                    type="checkbox"
                    label="I am the receiver"
                    checked={isReceiver}
                    onChange={(e) => setIsReceiver(e.target.checked)}
                    custom
                    id="custom-checkbox"
                    style={{
                        "--bs-form-check-input-bg-checked": "#6C47FF !important",
                        "--bs-form-check-input-check-color-checked": "#ffffff  !important",
                        "--bs-form-check-input-border-color-checked": "#6C47FF  !important",
                        boxShadow: "none",
                    }}
                    className="[&>*]:!shadow-none custom-checkbox"
                />
            </div>

            <div className="flex !gap-9 justify-end !mt-6">
                <button
                    onClick={() => goToStep(ADD_PAYMENT_INFO)}
                    type="button"
                    className="button text-[#1D2939] font-[450] !py-2 !px-6"
                >
                    Back
                </button>
                <button
                    onClick={() => goToStep(SHIPMENT_SUMMARY)}
                    disabled={!isForthStepValid}
                    className={`!py-2 !px-6 text-white rounded-lg font-[450] ${
                        !isForthStepValid ? "!bg-[#D9CDFF]" : "!bg-secondary"
                    }`}
                    type="submit"
                >
                    {isLoading ? "Loading..." : "Continue"}
                </button>
            </div>
            {/* <AddReceiversModal openModal={show} setOpenModal={setShow} /> */}
        </>
    );
};

export default AddReceiverInfo;
